import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { CommonFunctionService ,UserPOSData} from "../../../../services/Common/common-function.service";
import { Validators, FormControl } from "@angular/forms";
import * as CryptoJS from 'crypto-js';
import { ItemServiceService } from 'src/app/POS/POSServices/Setup/item-service.service';
const _clone = (d) => JSON.parse(JSON.stringify(d));
@Component({
  selector: 'app-item-list',
  templateUrl: './item-list.component.html',
  styleUrls: ['./item-list.component.scss']
})
export class ItemListComponent implements OnInit {
  isreportsbtnActive: boolean = false;
  listsofItem:any;
  isStartDateGreaterthenEndDate: boolean = false;
  Range = [
    { text: "Today", value: "0" },
    { text: "Yesterday", value: "2" },
    { text: "current week", value: "4" },
    { text: "Last Week", value: "1" },
    { text: "This Month", value: "1" },
    { text: "Last Month", value: "2" },
    { text: "Custom Date Range", value: "4" }
  ];
  Type = [
    { text: "Fixed", value: "Fixed" },
    { text: "Variable", value: "Variable" },
    { text: "Per Unit", value: "Per Unit" },


  ]; 

  symbol = [
    { text: "=", value: "1" },
    { text: "<", value: "2" },
    { text: ">", value: "4" },
    { text: "<=", value: "1" },
    { text: ">=", value: "2" },
    { text: "<>", value: "4" },
  ];
  amountcheck= new FormControl("", [Validators.required]);
  fromdate = new FormControl("", [Validators.required]);
  todate = new FormControl("", [Validators.required]);
  priceType= new FormControl("", [Validators.required]);
  Fromdate1: any;
  todate1: any;
   Dfiltering:boolean = true;
  Rfromdate: boolean = false;
  isCustomDateSelected: boolean = false;
  daterange = new FormControl("", [Validators.required]);
  ItemName = new FormControl("", [Validators.required]);
  AlterNativeName = new FormControl("", [Validators.required]);
  CategoryName = new FormControl("", [Validators.required]);
  Price = new FormControl("", [Validators.required]);
  filtering:boolean=false;
  Categorylist=[];
  editing = {};
  rows = [];
  rowsFilter = [];
  rowsExp = [];
  rowsSort = [];
  temp = [];
  expanded: any = {};
  timeout: any;

  rowsSel = [];
  selected = [];
  currency:any;
  constructor(
    private commonfunction: CommonFunctionService,  private service: ItemServiceService,
  ) { 
    this.currency = this.commonfunction.GetCurrencysymbol();
    this.GetitemList((data) => {
  });
}
  // this.GetitemcategoryList((data) => {
  //   // cache our list
  //   this.temp = _clone(data);
  //   this.Categorylist = _clone(data);
  //  this.displaycategoryname();
   
  //  });
  // }
  // GetitemcategoryList(cb) {
  //   let merchantdata: UserPOSData=this.commonfunction.getUserPOSData();
  //   const req = new XMLHttpRequest();
  //   req.open('GET',environment.GetItemCategoryListUrl+"?posSubscriptionId="+merchantdata.PosSubscriptionId);
  // //   req.open('GET', `https://uatapi.fastswiff.com/virtualPOS/api/PrepaidCards/Manage?MerchantKeyId=3`);
  
  //   req.onload = () => {
  //       cb(JSON.parse(req.response));
  //   };
  
  //   req.send();
  // }
  GetitemList(cb) {
    let merchantdata: UserPOSData=this.commonfunction.getUserPOSData();
    const req = new XMLHttpRequest();
    this.listsofItem=localStorage.getItem('itemslist')

    if(this.listsofItem ==null)
    { 
       this.service.GetItemList(merchantdata.PosSubscriptionId).subscribe(data => {   
      if(data !=null)
      {
        this.temp = _clone(data);
        this.rows = _clone(data);;
        this.rowsFilter = _clone(data);;
        this.rowsExp = _clone(data);
        this.rowsSort = _clone(data);
        this.rowsSel = _clone(data);
        var  Customerlist = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(this.rows), 'Secret Passphrase').toString());
  localStorage.setItem("itemslist",Customerlist);
      }
    });
    //    req.open('GET',environment.GetItemList+"?posSubscriptionId="+merchantdata.PosSubscriptionId);
    // req.onload = () => {
    //     cb(JSON.parse(req.response));
    //     var encrypted = CryptoJS.AES.encrypt(req.response, "Secret Passphrase", {
    //     });
    //      localStorage.setItem("itemslist",encrypted);
  //   };
  
  
  // req.send();
   }

   else
   {
    let  decrypteddata = localStorage.getItem('itemslist');
var deData= CryptoJS.AES.decrypt(decodeURIComponent(decrypteddata), 'Secret Passphrase'); 
let data=deData.toString(CryptoJS.enc.Utf8);
 if(data =="")
 {
   localStorage.removeItem('itemslist');
   window.location.reload();
 }
 else
 {
   this.rows=JSON.parse(data);
   if(this.rows.length !=0)
   {
     if(this.rows[0].posSubscriptionId==merchantdata.PosSubscriptionId)
     {
     this.rows=JSON.parse(data);
     }
     else{
     this.rows=[];
     localStorage.removeItem('itemslist');
      window.location.reload();
     }
   }
   else
   {
     localStorage.removeItem('itemslist');
     window.location.reload();
   }
 }
 
 
   }

  }
// displaycategoryname()
// {
//   for(let i=0;i<this.Categorylist.length;i++)
//   {
//   for(let j=0; j<this.rows.length;j++)
//    {
//      if(this.Categorylist[i].id==this.rows[j].categoryId)
//    {
//     this.rows[j].categoryId=this.Categorylist[i].categoryName;
//    }
   
//    }
    
   
//   }
// }


  ngOnInit() {
   
  }


  filters()
  {
    this.filtering = !this.filtering;
  }
  selectedaterange() {
    var daterange = this.daterange.value;
    if (daterange == "Custom Date Range") {
      this.isCustomDateSelected = true;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = true;
      this.Dfiltering = false;
    }
    else {
      this.isCustomDateSelected = false;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = false;
     // this.search();

    }
  }
  search() {
    this.GetCustomerFilrterData((data) => {
      // cache our list
      // this.temp = _clone(data);
      // this.rows = _clone(data);;
      // this.rowsFilter = _clone(data);;
      // this.rowsExp = _clone(data);
      // this.rowsSort = _clone(data);
      // this.rowsSel = _clone(data);
    });
  }
  GetCustomerFilrterData(cb) {
    var daterange = this.daterange.value;
    var itemname = this.ItemName.value;
    var alternativename = this.AlterNativeName.value;
    var Categoryname = this.CategoryName.value;
    if(Categoryname=="")
    {
     Categoryname='0'
    }
    var price = this.Price.value;
    if(price == "")
    {
      price='0';
    }
    var priceType=this.priceType.value;
    if(priceType =="Fixed")
    {
      priceType='0';
    }
    else if(priceType =="Variable")
    {
      priceType='1';
     
    }
    else if(priceType =="Per Unit")
    {
      priceType='2';
   
    }
   else if(priceType=="")
    {
      priceType='4';
    }
    var symbol=this.amountcheck.value;
    if (daterange == "Today") {

      this.Fromdate1 = new Date().toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);


    }
    else if (daterange == "Yesterday") {
      const today = new Date();
      const tomorrow = new Date(today.setDate(today.getDate() - 1)).toISOString().slice(0, 10);
      this.Fromdate1 = tomorrow;
      this.todate1 = tomorrow;

    }
    else if (daterange == "current week") {
      const today = new Date();
      const tomorrow = new Date(today.setDate(today.getDay()));


      var current = new Date();
      var weekstart = current.getDate() - current.getDay() + 1;
      var weekend = weekstart + 6;
      this.Fromdate1 = new Date(current.setDate(weekstart)).toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);

    }
    else if (daterange == "Last Week") {
      var curr = new Date;
      var first = curr.getDate() - curr.getDay() - 6;
      var last = first + 6;
      this.Fromdate1 = new Date(curr.setDate(first)).toISOString().slice(0, 10);
      this.todate1 = new Date(curr.setDate(last)).toISOString().slice(0, 10);


    }
    else if (daterange == "This Month") {
      const today = new Date();
      // const thismonth = new Date(today.setDate(today.getMonth())).toISOString().slice(0, 10);
      //this.Fromdate1=thismonth;   
      this.Fromdate1 = new Date(today.getFullYear(), today.getMonth(), 1).toDateString();
      this.todate1 = new Date().toISOString().slice(0, 10);

    }
    else if (daterange == "Last Month") {
      // var date = new Date();                
      // this.Fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toISOString().slice(0,10);
      // this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toISOString().slice(0,10);
      var date = new Date();
      this.Fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toDateString();
      this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toDateString();


    }
    else if (daterange == "Custom Date Range") {

      this.Fromdate1 = this.fromdate.value;
      this.todate1 = this.todate.value;
    }
    else {
      this.Fromdate1 = '01/01/1990';
      this.todate1 ='01/01/1990';
    }
    let merchantdata: UserPOSData=this.commonfunction.getUserPOSData();
    const req = new XMLHttpRequest();
    //this.service.FilteringitemDetails(merchantdata.PosSubscriptionId,this.Fromdate1,this.todate1,itemname,alternativename,Categoryname,price,priceType,symbol).subscribe(data => {  
      let form = {
        PosSubscriptionId:merchantdata.PosSubscriptionId,
        FromDate:this.Fromdate1, 
        ToDate:this.todate1,
        ItemName:itemname,
        AlternativeName:alternativename,
        Categoryname:Categoryname,
        Price:price,
        PriceType:priceType,
        Symbol:symbol
  
  
      };
      this.service.FilteringitemDetails(form).subscribe(data => { 
    if(data !=null)
    {
      this.temp = _clone(data);
      this.rows = _clone(data);;
    }});
    // req.open('GET',
    //   environment.FilteringitemDetails+"?PosSubscriptionId="+merchantdata.PosSubscriptionId+"&fromdate="+this.Fromdate1+"&todate="+this.todate1+"&ItemName="+ 
    //   itemname+"&AlternativeName="+alternativename+"&CategoryName="+Categoryname+"&price="+price+"&PriceType="+priceType +"&symbol="+symbol);
    // req.onload = () => {
    //   cb(JSON.parse(req.response));
    // };
    // req.send();
  }




  clearcache()
{
  localStorage.removeItem('itemslist');
  window.location.reload();
}
checkDateRange() {
  if (this.fromdate.value != "" && this.todate.value != "") {
      if (this.fromdate.value > this.todate.value) {
          this.isreportsbtnActive = false;
          this.isStartDateGreaterthenEndDate = true;
      }
      else {
          this.isreportsbtnActive = true;
          this.isStartDateGreaterthenEndDate = false;
      }
  }
  else {
      this.isreportsbtnActive = false;
      this.isStartDateGreaterthenEndDate = false;
  }
}
resetForm(){
  this.ItemName.reset('');
  this.AlterNativeName.reset('');
  this.amountcheck.reset('');
  this.Price.reset('');
  this.priceType.reset('');
  this.daterange.reset('');
  this.fromdate.reset('');
  this.todate.reset('');
  this.rows=[];
}
}
